import Link from 'next/link';
import {
  MiniFixtureTicker,
  useMiniFixtureTickerData
} from '@components/fixtures/v2/MiniFixtureTicker';
import { FIXTURE_TICKER_PATH, MAX_GAMEWEEK } from '@lib/constants';
import CaptaincyPoll from '@components/CaptaincyPoll';
import { PostHogFeatureFlags } from '@lib/posthog-feature-flags';
import { usePostHogFeatureFlag } from '@hooks/usePostHogFeatureFlag';
import { useLeagueContext } from '@hooks/useLeagueContext';

const TICKER_HEADING_ID = 'fixture-ticker-title';

const RightSidebar = () => {
  const { context: leagueContext } = useLeagueContext();
  const currentGameweek = leagueContext?.currentGameweek?.number ?? 0;

  const fplSeasonIsClosed = usePostHogFeatureFlag(
    PostHogFeatureFlags.fplSeasonIsClosed,
    false
  );

  const { shouldShowTicker } = useMiniFixtureTickerData();

  const communityVoteIsLive = usePostHogFeatureFlag(
    PostHogFeatureFlags.communityVoteIsLive,
    false
  );

  const seasonIsClosed = fplSeasonIsClosed || currentGameweek === MAX_GAMEWEEK;

  return (
    <div className="pt-10 mb-14">
      <h2 className="m-0 flex min-h-[42px] items-end font-sans text-[28px] font-bold leading-9 text-neutral-800">
        Community & tools
      </h2>
      {shouldShowTicker && (
        <section
          aria-labelledby={TICKER_HEADING_ID}
          className="mt-7 mb-12 rounded-[12px] border border-neutral-200 bg-white p-4 shadow"
        >
          <div className="flex items-baseline justify-between">
            <h4
              id={TICKER_HEADING_ID}
              className="m-0 font-sans text-[17px] font-semibold text-neutral-800"
            >
              Fixture ticker
            </h4>
            <Link
              href={FIXTURE_TICKER_PATH}
              className="font-open-sans text-xs font-semibold text-primary-700 hover:underline"
            >
              Full ticker
            </Link>
          </div>
          <Link
            href={FIXTURE_TICKER_PATH}
            aria-hidden="true"
            tabIndex={-1}
            className="mt-1.5 block cursor-pointer"
          >
            <div className="pointer-events-none">
              <MiniFixtureTicker />
            </div>
          </Link>
        </section>
      )}
      {seasonIsClosed || !communityVoteIsLive ? null : (
        <CaptaincyPoll placement="sidebar" className="mt-7" />
      )}
    </div>
  );
};

export default RightSidebar;
